export default __webpack_public_path__ + "static/media/AMZN_IT_SH.08c94938.svg";